import google from "../assets/images/clients/google.png";
import gojek from "../assets/images/clients/gojek.png";
import tokopedia from "../assets/images/clients/tokopedia.png";
import traveloka from "../assets/images/clients/traveloka.png";

export const clientsList = [
  { id: "google", name: "Google", image: google, link: "#" },
  { id: "gojek", name: "Gojek", image: gojek, link: "#" },
  { id: "tokopedia", name: "Tokopedia", image: tokopedia, link: "#" },
  { id: "traveloka", name: "Traveloka", image: traveloka, link: "#" }
];
